import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icone-divider',
  templateUrl: './icone-divider.component.html',
  styleUrls: ['./icone-divider.component.css'],
  standalone: false,
})
export class IconeDividerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
